'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var slideInDown = {
  from: {
    transform: (0, _utils.translate3d)(0, '-100%', 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, _utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInDown;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/slide-in-down.js
// module id = 255
// module chunks = 54990529738226 257444579329143